import config from '../../config'
import { IAxiosSuccess } from '../interface'
import server from '../axiosInstance'
import { ContentType } from '../header'
import { TaskActivityUserProgressType, TaskActivityWebConfigType } from '../types/task'

const { baseURL } = config

/**
 * 获取任务类活动UI数据
 * http://yapi.xf.io/project/536/interface/api/19707
 * @param id 活动id
 * @returns
 */
export const getTaskActivityWebConfigList = (id: string): Promise<IAxiosSuccess<TaskActivityWebConfigType>> => {
  return server.request<null, IAxiosSuccess<TaskActivityWebConfigType>>({
    url: `${baseURL}/v1/activityTask/webConfigList`,
    method: 'GET',
    headers: {
      'Content-Type': ContentType.JSON
    },
    needAuth: true,
    params: {
      id
    }
  })
}

/**
 * 获取任务类活动用户进度
 * http://yapi.xf.io/project/536/interface/api/19875
 * @param id 活动id
 * @param uid 用户uid
 * @returns
 */
export const getTaskActivityUserProgress = (uid: number, id: string, type?: number): Promise<IAxiosSuccess<TaskActivityUserProgressType>> => {
  return server.request<null, IAxiosSuccess<TaskActivityUserProgressType>>({
    url: `${baseURL}/v1/activityTask/userProgress`,
    method: 'GET',
    headers: {
      'Content-Type': ContentType.JSON
    },
    needAuth: true,
    params: {
      id,
      uid,
      type
    }
  })
}
